<template>
    <div>
        <div @drop="">
            <b-container 
                style="position: relative; padding: 20px; text-align: center; cursor: pointer;">
            
                <b-form-file 
                    v-model="file" 
                    :accept="acceptedFiles"
                    class="modal-file-upload-input" 
                    />
                <b-row>
                    <b-col class="text-center bg-primary lighten-100" style="border-radius: 10px">
                        <div class="p-4 text-primary">
                            <font-awesome-icon icon="folder-open" size="6x" />
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="py-4 text-center">
                        <h6>DRAG OR DROP .xls or .xlsx file only</h6>
                        <p class="text-muted text-caption">
                            Drop your XLS/XLSX file containing Divalto codes
                        </p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
      <b-container v-if="progress">
          <b-row class="flex-nowrap shadow px-2 py-1" align-v="center">
              <b-col cols="auto" class="px-0">
                  <font-awesome-icon 
                      icon="file-zipper" 
                      size="2x" 
                      class="text-primary"
                      transform="shrink-7" 
                      mask="square" />
              </b-col>
              <b-col >
                  <div class="text-truncate" style="font-size:12px">
                      {{ file.name}}
                  </div>
                  <b-progress class="mb-1" :value="progress.percent" :max="100" height="0.5em">
                  </b-progress>
              </b-col>
              <b-col cols="auto" class="px-0">
                  <b-spinner small variant="primary" v-if="progress.percent < 100"></b-spinner>
                  <font-awesome-icon v-else
                      icon="check-circle" 
                      class="text-success"
                  />

              </b-col>
          </b-row>
      </b-container>
  </div>
</template>
<script>
import {$assets} from '@/services';
import appConfig from '@/config/app.config'
import axios from 'axios';
export default {
    name: "DivaltoImport",
    watch:{
        file(){
          if(this.file){
            this.progress = {
              percent: 10,
            }
            this.upload()
          }
        }
    },
    computed: {
      acceptedFiles: function(){
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
      }
    },
    data(){
        return {
            file: null,
            progress: null,
            isDragging: false,
        };
    },
    
    methods:{
        async upload(){
            await this.$store.dispatch('session/refresh')

            let payload = new FormData();
            payload.append("file", this.file);

            axios.post(appConfig.API_BASE_URL + '/divalto_codes/import', payload, {
                headers: {
                    "Authorization": this.$store.getters['session/currentToken']
                },
                onUploadProgress: this.uploadProgressHandler
            }).then((res) => {
                this.$store.dispatch('ui/modal.close')
            }).catch(err => {
                this.debug('google-error', err);
            });

        },

        uploadProgressHandler(event){
            event.percent = event.progress.toFixed(2) * 100
            this.progress = event
        }

    }
    
}
</script>
<style>
    .modal-file-upload-input{
        position:absolute !important; 
        top: 0; 
        left: 0; 
        width:100% !important; 
        height: 100% !important;
        opacity: 0;
        z-index: 10;
    }
    .modal-file-upload-input .custom-file-input{
      height: 100%;
      z-index: 999 !important;
    }
</style>
